export const MERGE_TAG_REPLACED_VALUE_PREFIX = `<span class="merge_tag_value"></span>`;

export const NORMALIZE_TAG_CONTENT_REGEXP = new RegExp(
  /(<span class="mce-mergetag" contenteditable="false" data-mce-cef-wrappable="true" data-mce-mergetag="1"><span class="mce-mergetag-affix" data-mce-mergetag-affix="">).*?(<\/span><\/span>)/g
);
